import { render } from "./LeButton.vue?vue&type=template&id=3fc5d330"
import script from "./LeButton.vue?vue&type=script&lang=js"
export * from "./LeButton.vue?vue&type=script&lang=js"

import "./LeButton.vue?vue&type=style&index=0&id=3fc5d330&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__